import storage from 'util/storage'
import config from 'config'
import { MOUNTED } from './constants'

export function selectLayoutMounted(start) {
  const { reports: { layout } = {} } = start
  return layout === MOUNTED
}
